export interface JobRequirementAttachment {
  dateModified: string;
  description: string;
  fileID: string;
  fileName: string;
  manPowerAttachmentID: string;
  manPowerReqID: string;
  modifiedUserID: string;
  modifiedUserName: string;
  plantID: string;
  type: string;
  typeName: string;
  bActive: string;
  file: unknown;
}
